<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex
        v-show="$vuetify.breakpoint.mdAndUp && expertMode"
        xs6
      >
        <v-slider
          always-dirty
          color="grey lighten-1"
          hint="Relaxation duration in days before magnetogram time"
          id="relaxation"
          inverse-label
          max="0"
          min="-15"
          persistent-hint
          step="1"
          thumb-color="primary"
          thumb-label="always"
          track-color="primary"
          v-model="relaxation"
        ></v-slider>
      </v-flex>
      <v-flex
        :xs6="expertMode"
        :xs12="!expertMode"
        v-show="$vuetify.breakpoint.mdAndUp"
      >
        <v-slider
          always-dirty
          color="success"
          hint="Forecast duration in days after magnetogram time"
          max="15"
          min="0"
          persistent-hint
          step="1"
          thumb-label="always"
          v-model="myRun.config.heliospheric_model.Duration.forecast"
        ></v-slider>
      </v-flex>
      <v-flex
        class="px-2"
        sm6
        v-show="!$vuetify.breakpoint.mdAndUp && expertMode"
        xs12
      >
        <v-text-field
          hint="Relaxation in days before magnetogram time"
          label="Relaxation"
          suffix="days"
          type="number"
          v-model="myRun.config.heliospheric_model.Duration.relaxation"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        :sm6="expertMode"
        v-show="!$vuetify.breakpoint.mdAndUp"
        xs12
      >
        <v-text-field
          hint="Forecast in days after magnetogram time"
          label="Forecast"
          suffix="days"
          type="number"
          v-model="myRun.config.heliospheric_model.Duration.forecast"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
  computed: {
    relaxation: {
      get() {
        return -this.myRun.config.heliospheric_model.Duration.relaxation;
      },
      set(value) {
        this.myRun.config.heliospheric_model.Duration.relaxation = -value;
      },
    },
  },
};
</script>
